import { render, staticRenderFns } from "./FormularioManifesto.vue?vue&type=template&id=c0d9ddae&scoped=true"
import script from "./FormularioManifesto.vue?vue&type=script&lang=js"
export * from "./FormularioManifesto.vue?vue&type=script&lang=js"
import style0 from "./FormularioManifesto.vue?vue&type=style&index=0&id=c0d9ddae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d9ddae",
  null
  
)

export default component.exports